<template>
  <div>
    <div class="my-3 d-flex justify-content-end">
      <button
          class="btn btn-success"
          data-toggle="modal"
          data-target="#create_level_modal"
          type="submit"
          id="create_level"
      >
        {{ $t('label.add_level') }}
      </button>
    </div>
    <!--Create Modal-->
    <CreateLevelModal @refreshDatatable="refreshDatatable" />

    <kt-panel>
      <kt-panel-body>
        <kt-datatable ref="datatable" v-bind="datatableProps"></kt-datatable>
      </kt-panel-body>
    </kt-panel>
  </div>
</template>

<script>
import {AuthorizationHeader} from "@/common/jwt.service";
import columns from "@/views/wallets/AyandeWallets/datatable/level-columns";
import {StarShopApiUrl} from "@/common/api.service";
import Span from "@/components/elements/span.vue";
import CreateLevelModal from "@/views/wallets/AyandeWallets/components/CreateLevelModal.vue";
import actions from "@/views/wallets/AyandeWallets/datatable/level-actions.vue"

export default {
  name: "ShareholderSetting",
  components: {CreateLevelModal, Span},
  computed: {
    datatableProps() {
      return {
        id: "level_datatable",
        data: {
          type: 'remote',
          source: {
            read: {
              url: StarShopApiUrl.path('wallet/common/admin/shareholder-settings/levels'),
              method: 'GET',
              headers: AuthorizationHeader,
              map: res => {
                return res.data.data;
              },
              params: this.query,
            }
          },
          pageSize: 10,
          serverPaging: true,
          serverFiltering: true,
          serverSorting: true,
        },
        layout: {},
        pagination: false,
        columns: columns,
        actions: actions
      }
    }
  },
  methods: {
    refreshDatatable() {
      if (this.$refs.datatable.KTDatatable) {
        this.$refs.datatable.reload()
      }
    }
  }
}
</script>

<style scoped>

</style>